import ApiService from '../../../../shared/services/api-service';
import commonActionCreators from '../../../../shared/store/common/action-creators';
import myProfileCommitTypes from '../commit-types';
import notificationsActionsCreator from '../../notifications/action-creators';

const myProfileActionsCreators = {
  fetchMyProfile() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchMyProfile'));
      const data = await ApiService.get('/api/v1/my-profile')
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('fetchMyProfile'));
      if (data.error) {
        dispatch(commonActionCreators.handleApiError(data.error));
      } else {
        dispatch(this.setMyProfile(data));
      }
    };
  },
  replaceMyProfile(profile) {
    return {
      profile,
      type: myProfileCommitTypes.REPLACE_MY_PROFILE,
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: myProfileCommitTypes.SET_MY_PROFILE_IS_LOADING,
    };
  },
  setMyProfile(profileResponse) {
    return {
      profile: profileResponse.data,
      type: myProfileCommitTypes.SET_MY_PROFILE,
    };
  },
  updateMyProfile(formData) {
    const patchData = {
      data: formData,
      patched: 'details',
    };
    return async (dispatch) => {
      dispatch(this.setIsLoading('updateMyProfile'));
      const data = await ApiService.patch('/api/v1/my-profile', patchData)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('updateMyProfile'));
      if (data.error) {
        dispatch(commonActionCreators.handleApiError(data.error));
      } else {
        dispatch(this.updateMyProfileSuccess(data));
      }
    };
  },
  updateMyProfileSuccess(updated) {
    return (dispatch) => {
      dispatch(this.replaceMyProfile(updated.data));
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Profile updated'))
    };
  },
};

export default myProfileActionsCreators;
